import { DialogButton, DialogCloseButton, DialogHeader, DialogTitle } from '../../Dialog'
import { MoreHorizIcon } from '../../../assets/icons'
import { FileViewerMenu } from './FileViewerMenu'
import React, { useState } from 'react'
import { Box } from '@mui/system'
import { FileViewerMenuAction } from './FileViewerDialog'
import File from '../../../icons/File'
import { Tooltip, Typography } from '@mui/material'
import EmailAttachmentModel from '../../../models/Attachment'

export interface EmailAttachmentsSidebarProps {
  onSelectAction: (action: FileViewerMenuAction) => void
  onClose: () => void
  fileName: string
  attachmentsList: EmailAttachmentModel[]
  onOpenAttachmentFromList: (id: string) => void
}

export function EmailAttachmentsSidebar({
  onClose,
  fileName,
  onSelectAction,
  attachmentsList,
  onOpenAttachmentFromList
}: EmailAttachmentsSidebarProps) {
  const [optionsAnchorEl, setOptionsAnchorEl] = useState<HTMLElement | null>(null)

  return (
    <Box className="flex flex-col flex-grow max-w-[480px]">
      <DialogHeader
        leadingAccessory={<DialogTitle title={<div className="truncate max-w-[250px]">{fileName}</div>} />}
        trailingAccessory={
          <>
            <DialogButton onClick={(e) => setOptionsAnchorEl(e.currentTarget)} Icon={MoreHorizIcon} />

            <DialogCloseButton onClick={onClose} />
            <FileViewerMenu
              actions={[FileViewerMenuAction.Download]}
              onClose={() => setOptionsAnchorEl(null)}
              onSelectAction={onSelectAction}
              anchorElement={optionsAnchorEl}
            />
          </>
        }
      />

      <Box className="p-5 pt-0 gap-1 flex flex-col overflow-y-scroll">
        {attachmentsList.map((attachment) => (
          <Tooltip title={attachment.name} key={attachment.id}>
            <Box
              onClick={() => onOpenAttachmentFromList(attachment.id)}
              key={attachment.name}
              className="px-2 py-1 cursor-pointer flex justify-between items-center border-solid border-[1px] border-grey-200 rounded"
            >
              <Box className="flex gap-2.5 items-center">
                <File fontSize="small" sx={{ color: '#697586' }} />
                <Typography className="truncate">{attachment.name}</Typography>
              </Box>
            </Box>
          </Tooltip>
        ))}
      </Box>
    </Box>
  )
}
